/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Custom_Properties_Open_Contact_Detail_Before_AcceptingInputs */

const en_tables_custom_properties_open_contact_detail_before_accepting = /** @type {(inputs: Tables_Custom_Properties_Open_Contact_Detail_Before_AcceptingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Properties Open Contact Detail Before Accepting`)
};

const de_tables_custom_properties_open_contact_detail_before_accepting = /** @type {(inputs: Tables_Custom_Properties_Open_Contact_Detail_Before_AcceptingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt Detail vor Annahme öffnen`)
};

/**
* | output |
* | --- |
* | "Properties Open Contact Detail Before Accepting" |
*
* @param {Tables_Custom_Properties_Open_Contact_Detail_Before_AcceptingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_custom_properties_open_contact_detail_before_accepting = /** @type {((inputs?: Tables_Custom_Properties_Open_Contact_Detail_Before_AcceptingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Custom_Properties_Open_Contact_Detail_Before_AcceptingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_custom_properties_open_contact_detail_before_accepting(inputs)
	return de_tables_custom_properties_open_contact_detail_before_accepting(inputs)
});